import styles from "./OnboardingStyles.module.css"
import { useEffect, useState } from 'react';
import PrimaryButton from "../Button/PrimaryButton/PrimaryButton";
import { StepFormProps } from "../../types/onboarding.types";
import { useNavigate } from "react-router-dom";
import RecommendLoader from "./RecommendLoader";
import ProductSmall from "../ProductCards/ProductSmall/ProductSmall";
import { useProducts } from "../../context/ProductContext";
import { Product, Package } from "../../types/product.types";
import { filterRecommendedProducts } from "../../utils/filters";
import { useTranslation, Trans } from "react-i18next";
import { useFilterContext } from "../../context/FilterContext";
import { applySelected } from "../../utils/filters";
import { getTags } from "../../constants/tags";
import { log } from "../../utils/logger";
/**
* Props for the Recommended component.
*/ 
interface RecommendedProps extends StepFormProps{
    onEnd?: () => void, // Onboarding end handler
    popup?: boolean // Optional flag - whether onboarding is in form of popup
}
/**
* Onboarding part showing recommended products based on onboarding data.
*
* @param props StepFormProps
* @param {() => void} props.onEnd - Onboarding end handler
* @param {(step: number) => void} props.setStep - Step change handler
* @param {number} props.currentStep - Current step
* @param {OnboardingFormData} props.formData - Onboarding data
* @param {React.Dispatch<React.SetStateAction<OnboardingFormData>>} props.setFormData - Onboarding data change handler
* @param {() => void} props.clearData - Clear data handler
* @returns TSX.Element
*/
const Recommended = ({ setStep, onEnd, formData, clearData, popup}:RecommendedProps) => {
    const { t } = useTranslation(); // Translation
    const { allProducts, packages, loading, reloadProducts} = useProducts(); // Products
    // Reload products if they are loaded but dont appear
    useEffect(() => {
        if (!loading && !allProducts) {
            reloadProducts();
        }
    },[loading])
    const [recommendedProducts, setRecommendedProducts] = useState<(Product | Package)[]>([])
    const navigate = useNavigate();
    const [isFetching, setIsFetching] = useState(false);// when to show the lkoader
    const { filterData, setAllFilters} = useFilterContext();
    const tags = getTags(t);
    // Loader simulation
    useEffect(() => {
        // Simulate fetching data
        const timer = setTimeout(() => {
            setIsFetching(true);
        }, 10000); // simulate 2s loading 10000
        //log(formData)
        return () => clearTimeout(timer);
    }, []);

    // Handle redirecting home
    const handleHome = () => {
        if(clearData) clearData(); // Clear data
        if(onEnd){
            onEnd(); 
        }else{
            navigate("/home")
        }
    }

    const goToTopOfProduct = () => {
        document.getElementById('OfferSection')
        ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    

    // Handle recommending products
    useEffect(()=>{
        const filteredProducts = filterRecommendedProducts([...allProducts, ...packages], formData, 4)
        setRecommendedProducts(filteredProducts);
    },[])

    // Return loader when fetching
    if (!isFetching) return <RecommendLoader />;

    return(
        <>
        <div className={styles.RecommendCenter}>
            <div className={styles.RecommendContainer}>
                <div className={styles.RecommendTitle}>
                    <p>{t("onboarding.recommended.title")}</p>
                </div>
                <div className={styles.RecommendedProducts}>
                    {recommendedProducts.map((product,i)=>{
                        if (i< 5) return<ProductSmall  product={product} type={product.type ?? "sales"} onPopup={popup}/>
                    })}
                    {recommendedProducts.length === 0 && (
                            <>
                                <div className={styles.EmptyRecom}>
                                    <p className={styles.EmptyText}>
                                        <Trans i18nKey="products.recom_not_found" components={{ 1: <br/> }} />
                                        <a href="mailto:catermat@catermat.com" target="_blank">catermat@catermat.com</a>
                                    </p>
                                </div>
                            </>        
                    )}
                    
                </div>     
                <div className={styles.HomeButton}>
                    <PrimaryButton onClick={()=>{
                        handleHome(); 
                        goToTopOfProduct();
                        applySelected(
                        {
                            diety: formData.specialRequests ?? [],
                            prilezitosti: formData.actionType ?? [],
                            // add more categories if you need
                        },
                        filterData,
                        setAllFilters,
                        tags
                        );
                        
                        }} text={t("buttons.proceed_to_eshop")}/>
                </div>
            </div>
        </div>
        </>
    )
};

export default Recommended;
